module.exports = __webpack_public_path__ + "static/img/Royal_Flush.04bb9a5.svg";